import React, { useEffect, useState } from 'react';
import 'devicon/devicon.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './components/layout/Layout.jsx';
import Routing from './routing.js';
import { HelmetProvider } from 'react-helmet-async';
import {
  getAsideEntries,
  getResumeEntries,
  getAboutSections,
  getProjects,
} from './api/api';
import './App.css';

import OfflinePage from './pages/OfflinePage';
import ErrorPage from './pages/ErrorPage';
import Loader from './components/Loader/Loader';
import CookieConsent from './components/legal/CookieConsent';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [error, setError] = useState(null);
  const [offline, setOffline] = useState(!navigator.onLine);
  const [loading, setLoading] = useState(true);

  // Nasłuchiwanie zmiany statusu sieci
  useEffect(() => {
    const goOnline = () => setOffline(false);
    const goOffline = () => setOffline(true);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  useEffect(() => {
    if (loading) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, [loading]);

  // w razie potrzeby można ograniczyć się aside i about
  // Prefetch danych (about , aside)
  useEffect(() => {
    const prefetchImportantData = async () => {
      try {
        await Promise.all([
          getAsideEntries(),
          getResumeEntries(), // optional
          getAboutSections(),
          getProjects(), //optional
        ]);
      } catch (err) {
        console.error('Błąd prefetchu:', err);
        setError('Wystąpił problem z pobraniem danych.');
      } finally {
        setLoading(false);
      }
    };

    prefetchImportantData();
  }, []);

  // kiedy brak internetu
  if (offline) return <OfflinePage />;

  // kiedy błąd pobierania danych
  if (error) return <ErrorPage message={error} />;

  return (
    <>
      {loading && <Loader />}

      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <Layout>
            <Routing />
          </Layout>
        </Router>
      </HelmetProvider>

      <CookieConsent />
    </>
  );
}

export default App;
